export const electronicCommunicationDisclosure = {
  v1: (
    <>
      <p>
        <strong>
          This Consent to Electronic Communications (the &quot;Consent&quot;) contains important
          information about your legal rights-please read it thoroughly and print or save a copy.
        </strong>{' '}
        As used in this Consent, <strong>&quot;Account&quot;</strong> means all accounts, products
        or services you have with us, and any products and services offered by our affiliates,
        agents, service providers, successors and assigns through or in conjunction with the website{' '}
        <a
          href="https://www.netcredit.com"
          rel="noreferrer noopener"
          target="_blank"
        >
          www.netcredit.com
        </a>
        . The words <strong>&quot;we,&quot; &quot;us&quot;</strong> and{' '}
        <strong>&quot;our&quot;</strong> refer to NC Financial Solutions, LLC, the NetCredit family
        of companies, Republic Bank &amp; Trust Company, Transportation Alliance Bank, Inc. d/b/a
        TAB Bank, and Quill Bank. The words <strong>&quot;I,&quot; &quot;you&quot;</strong>{' '}
        and <strong>&quot;your&quot;</strong> mean each holder of an Account with or through us.
        This disclosure covers all of your Accounts with or through us.
      </p>
      <ol>
        <li>
          <u>Legally Required Communications and Disclosures</u>. We must provide you with certain
          communications and disclosures in writing (i.e., you have a right to receive such
          communications on paper) pursuant to applicable laws and regulations. This information may
          be provided to you electronically if you agree to this Consent. Because all of our
          Accounts are provided online and use electronic means to deliver information, you must
          agree to this Consent to obtain and use an Account. This Consent will apply to each person
          named on your Account.
        </li>
        <li>
          <u>Required Consent; Categories of Communications</u>. By agreeing to this Consent, you
          agree that we may provide electronic delivery-which includes delivery{' '}
          <strong>
            to the website on which you access your Account, delivery by e-mail, or delivery by
            other electronic means-of agreements; disclosures; notices and other information and
            communications regarding your Accounts;
          </strong>{' '}
          the use of our websites; our relationship with you; and such other products, services or
          programs that may be made available to you (collectively, the{' '}
          <strong>&quot;Communications&quot;</strong>). Communications include, but are not limited,
          to the following:
          <ul>
            <li>This Consent and any updates thereto;</li>
            <li>
              Disclosures, agreements, notices and other information related to the opening,
              initiation, or maintenance of an Account, including but not limited to, account
              agreements, fee schedules or other disclosures or notices that may be required by the
              Electronic Fund Transfer Act, Truth in Lending Act, the Equal Credit Opportunity Act,
              the Fair Credit Reporting Act, the Gramm Leach Bliley Act, the Telephone Consumer
              Protection Act or other applicable federal or state laws and regulations;
            </li>
            <li>
              Periodic, annual, monthly or other statements, disclosures and notices relating to the
              maintenance or operation of an Account including, but not limited to account
              information, account activity, account inactivity, payments made or due, or other
              statements, disclosures or notices that may be required by the Electronic Fund Transfer
              Act, Truth in Lending Act, the Equal Credit Opportunity Act, the Fair Credit Reporting
              Act, the Gramm Leach Bliley Act or other applicable federal or state laws and
              regulations;
            </li>
            <li>
              Any notice or disclosure regarding an Account, such as a late fee, an overdraft fee,
              an overlimit fee, a fee for a draft, check or electronic debit returned for any
              reason, such as insufficient funds fee or a fee as a result of a stop payment order;
            </li>
            <li>
              Any notice of the addition of new terms and conditions or the deletion or amendment of
              existing terms and conditions applicable to Accounts;
            </li>
            <li>Our Privacy Notice and other privacy statements or notices;</li>
            <li>Certain tax statements or notices; and</li>
            <li>Any notices or disclosures required by applicable law.</li>
          </ul>
          <u>How to Withdraw Consent; Effect of Withdrawal</u>. You may withdraw this Consent at any
          time by contacting us by mail at 175 W. Jackson Blvd., Suite 600, Chicago, IL 60604 or by
          phone at (877) 392-2014. If you withdraw this Consent: (i) your access to certain
          elements or features of your Account may be limited or unavailable; (ii) you will remain
          responsible for any amounts that you owe us or may come due under any such Accounts; and
          (iii) any other obligations you have under any agreements governing such Accounts will
          remain in full force and effect. Withdrawal will not affect any Communications we provided
          to you prior to your withdrawal, and we will send any required further Communications to
          you in paper form. We will not impose any fee in connection with any withdrawal of this
          Consent or any Communication provided in paper form. Any withdrawal of this Consent will be
          effective only after we have a reasonable period of time to process your withdrawal
          request.
        </li>
        <li>
          <u>Retention of Electronic Communications</u>. You should print or make a copy of any
          Communications you receive by either using the &quot;Print&quot; button to print a copy or
          by saving a copy by downloading it to your computer.
        </li>
        <li>
          <u>Obtaining Paper Copies of Communications</u>. Upon request, we will provide you with a
          paper copy of any Communication that we have provided to you electronically. If you would
          like a paper copy of any Communication, please make the request by mail to 175 W. Jackson
          Blvd., Suite 600, Chicago, IL 60604 or by phone at (877) 392-2014. There will be no
          charge for a paper copy of any Communication we have sent to you electronically.
        </li>
        <li>
          <u>Hardware and Software Requirements</u>. To electronically receive and view and/or
          electronically save or print the Communications, you must have:
          <ul>
            <li>a personal computer with Internet access;</li>
            <li>
              a widely-used, recent-generation web browser (for example, Chrome, Safari or Firefox);
            </li>
            <li>
              a widely-used, recent-generation portable document file reader (for example, Adobe
              Reader);
            </li>
            <li>an email address;</li>
            <li>and either a printer, hard drive or other storage device.</li>
          </ul>
          You represent that you have the hardware, software, email address and email capacities
          described above, and your ability to read this Consent demonstrates that you have the
          necessary hardware and software to receive Communications electronically.
        </li>
        <li>
          <u>Updating Your Records</u>. You must immediately notify us of any change to your email
          address, contact information and other information related to this Consent and your
          Account(s). You can update this information by: mail at 175 W. Jackson Blvd., Suite 600,
          Chicago, IL 60604 or phone at (877) 392-2014. You represent and agree that you have
          provided us with a current e-mail address at which we may send electronic Communications to
          you.
        </li>
        <li>
          <u>Federal Law</u>. You acknowledge and agree this Consent is being provided in connection
          with a transaction affecting interstate commerce that is subject to the federal Electronic
          Signatures in Global and National Commerce Act (the <strong>&quot;ESIGN Act&quot;</strong>
          ), and that you and we both intend that the ESIGN Act apply to the fullest extent possible
          to validate our ability to conduct business with you by electronic means.
        </li>
        <li>
          <u>Reservation of Rights</u>. This Consent does not apply to any Communication that we
          determine, in our sole discretion, that we are required to deliver in paper form under
          applicable law or that you should receive in paper rather than electronic form. We reserve
          the right, in our sole discretion, to discontinue the provision of your electronic
          Communications, or to terminate or change the terms and conditions on which we provide
          electronic Communications. We will provide you with notice of any such termination or
          change as required by law.
        </li>
        <li>
          <u>Consent</u>. By clicking the checkbox, you hereby give your affirmative consent to
          provide electronic Communications to you as described above.
        </li>
      </ol>
    </>
  ),
} as const;
